import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import TextInput from '../../components/TextInput';
import useConfigStyles from '../../components/useConfigStyles';
import React, { useEffect, useState } from 'react';
import { useVariablesContext } from '../../stores/variables-context';
import { Identifier } from '../../types/identifier';
import { Variable } from '../../types/variable';

type JobVariableSelectsProps = {
  variables: Variable[];
  addVariable: (variable: Variable) => void;
  schoolYear: number | undefined;
};

const DefaultSelectVariable: Identifier = {
  Id: '0',
  Name: '',
};

function JobVariableSelect({ variables, addVariable }: JobVariableSelectsProps): JSX.Element {
  const classes = useConfigStyles();
  const [selectedVariable, setSelectedVariable] = useState<Identifier>(DefaultSelectVariable);
  const [jobVariableValue, setJobVariableValue] = useState('');
  const [buttonLabel, setButtonLabel] = useState('Add');
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [inputEnabled, setInputEnabled] = useState(true);
  const variablesContext = useVariablesContext();
  const hideVariables = ['SchoolYear', 'District'];

  useEffect(() => {
    if (variables.findIndex((v) => v.Name === selectedVariable.Name) >= 0) {
      setButtonLabel('Update');
    } else {
      setButtonLabel('Add');
    }
    setButtonEnabled(jobVariableValue !== '' && selectedVariable.Id !== '0');
  }, [jobVariableValue, selectedVariable, variables]);

  const handleVariableSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSelectedVariable({ Id: value, Name: value });
    setInputEnabled(true);
    setJobVariableValue('');
  };

  const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setJobVariableValue(value.replace("'", ''));
  };

  const handleOnClick = () => {
    addVariable({ Name: selectedVariable.Name, Value: jobVariableValue });
    setSelectedVariable(DefaultSelectVariable);
    setJobVariableValue('');
    setButtonEnabled(false);
  };

  return (
    <Grid container spacing={2} justifyContent='flex-end' alignItems='center' className={classes.container}>
      <Grid item md={10}>
        <TextInput name='Variables' label='Variables' value={selectedVariable.Id} onChange={handleVariableSelect} select>
          <MenuItem value='0'>Select...</MenuItem>
          {variablesContext.data.map((variable) => {
            return (
              hideVariables.indexOf(variable.Name) === -1 && (
                <MenuItem key={variable.Name} value={variable.Name}>
                  {variable.Name}
                </MenuItem>
              )
            );
          })}
        </TextInput>
      </Grid>
      <Grid item md={8}>
        <TextInput name='Value' label='Value' value={jobVariableValue} onChange={handleValueChange} editable={inputEnabled} />
      </Grid>
      <Grid item md={2}>
        <Button variant='contained' color='primary' type='button' onClick={handleOnClick} disabled={!buttonEnabled}>
          {buttonLabel}
        </Button>
      </Grid>
    </Grid>
  );
}

export default JobVariableSelect;
